<template>
  <div class="partydynamic">
    <div class="header">
      <!-- <div class="title">党建要闻</div> -->
      <img :src="party4" alt="" />
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="left">
        <div class="list">
          <div class="item" v-for="item in list" :key="item.id">
            <router-link
              :class="item.id < 4 ? 'active' : ''"
              :to="{ path: item.path, query: { id: item.id } }"
              >{{ item.title }}</router-link
            >
          </div>
        </div>
      </div>
      <div class="right">
        <el-carousel height="264px" class="relative">
          <el-carousel-item v-for="item in bannerList" :key="item.id">
            <img :src="item.logo ? item.logo : ''" alt="" />
            <div class="absolute">
              <div>
                <router-link :to="{ path: item.path, query: { id: item.id } }">
                  {{ item.title }}
                </router-link>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import party4 from "../../../assets/party/party4.png";

import partydynamic1 from "../../../assets/party/partydynamic1.png";
import partydynamic2 from "../../../assets/party/partydynamic2.png";
import partydynamic3 from "../../../assets/party/partydynamic3.png";
import partydynamic4 from "../../../assets/party/partydynamic4.png";

export default {
  setup() {
    return reactive({
      party4: party4,
      list: [
        {
          id: 1,
          title: "十二届上海市委首次中心组学习，为何要聚焦这个主题？",
          path: "/pc/party/partydetails",
          logo: partydynamic1,
        },
        {
          id: 2,
          title: "上海足迹 上海实践 上海眷念",
          path: "/pc/party/partydetails",
        },
        {
          id: 3,
          title: "上海：“把发展的油门踩下去”",
          path: "/pc/party/partydetails",
          logo: partydynamic2,
        },
        {
          id: 4,
          title: "未来的“确定性”从何而来？想一想，上海靠什么成为上海",
          path: "/pc/party/partydetails",
          logo: partydynamic3,
        },
        {
          id: 5,
          title: "这份行动纲领，对上海的发展具有决定性意义",
          path: "/pc/party/partydetails",
        },
        {
          id: 6,
          title: "上海市庆祝中国共产党成立101周年座谈会举行",
          path: "/pc/party/partydetails",
          logo: partydynamic4,
        },
      ],
      bannerList: [
        {
          id: 1,
          title: "十二届上海市委首次中心组学习，为何要聚焦这个主题？",
          path: "/pc/party/partydetails",
          logo: partydynamic1,
        },
        {
          id: 3,
          title: "上海：“把发展的油门踩下去”",
          path: "/pc/party/partydetails",
          logo: partydynamic2,
        },
        {
          id: 4,
          title: "未来的“确定性”从何而来？想一想，上海靠什么成为上海",
          path: "/pc/party/partydetails",
          logo: partydynamic3,
        },
        {
          id: 6,
          title: "上海市庆祝中国共产党成立101周年座谈会举行",
          path: "/pc/party/partydetails",
          logo: partydynamic4,
        },
      ],
    });
  },
};
</script>

<style scoped>
.partydynamic {
  width: 1180px;
  margin: 80px auto 0;
}
.header {
  text-align: center;
}
.header img {
  width: 129px;
  margin: 0 auto;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #a2231d;
  margin: 20px auto 0;
}
.body {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.body .left {
  width: 500px;
}

.body .right {
  width: 600px;
}
.body .right img {
  width: 100%;
}
.relative {
  position: relative;
}
.absolute {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 999;
  color: #fff;
  background: linear-gradient(180deg, rgba(159, 35, 29, 0) 0%, #9f231d 100%);
}
.absolute div {
  margin-left: 20px;
  margin-bottom: 20px;
}
.absolute a {
  color: #fff;
}
:deep(.el-carousel__indicators) {
  display: none;
}
.body .left .list .item {
  margin-bottom: 30px;
}
.body .left .list .item a {
  color: #333;
}
.body .left .list .item .active {
  color: #9f231d;
}
</style>
